import React from "react";

export const EveningIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M21.2968 15.3374C20.0254 15.9124 18.6141 16.2325 17.128 16.2325C11.5347 16.2325 7.00035 11.6982 7.00035 6.10482C7.00035 4.61874 7.32043 3.20742 7.8954 1.93604C4.38149 3.52516 1.93652 7.06138 1.93652 11.1686C1.93652 16.762 6.47083 21.2963 12.0642 21.2963C16.1715 21.2963 19.7077 18.8513 21.2968 15.3374Z"
      strokeWidth="1.93603"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
